import React, { useState, useEffect } from 'react';
import { Row, Col, Card, message, Empty } from 'antd';
import PujaSpinner from '../../components/PujaSpinner';
import { buyerService } from '../../services/api';

const MisSeguimientos = () => {
  const [loading, setLoading] = useState(true);
  const [seguimientos, setSeguimientos] = useState([]);

  useEffect(() => {
    fetchSeguimientos();
  }, []);

  const fetchSeguimientos = async () => {
    setLoading(true);
    try {
      const res = await buyerService.getMisSeguimientos();
      setSeguimientos(res.data || []);
    } catch (err) {
      message.error(err.response?.data?.error || 'Error al cargar seguimientos');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <PujaSpinner />;
  }

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>Animales en Seguimiento</h2>

      {seguimientos.length === 0 ? (
        <Empty description="No tenés animales en seguimiento" />
      ) : (
        <Row gutter={[16, 16]}>
          {seguimientos.map((s) => {
            const animal = s.animal || {};
            const imgSrc = animal.imagenes?.[0]?.url_imagen || null;
            return (
              <Col xs={24} sm={12} lg={6} key={s.id_seguimiento}>
                <Card
                  cover={
                    imgSrc ? (
                      <img
                        alt={animal.nom_animal}
                        src={imgSrc}
                        style={{ height: 160, objectFit: 'cover' }}
                      />
                    ) : null
                  }
                >
                  <Card.Meta
                    title={animal.nom_animal || `Animal #${s.id_animal}`}
                    description={
                      <>
                        <p style={{ margin: 0 }}>RP: {animal.rp_animal || '—'}</p>
                        {animal.cliente && (
                          <p style={{ margin: 0 }}>Cabaña: {animal.cliente.razon_social}</p>
                        )}
                        {s.id_evento && (
                          <p style={{ margin: 0 }}>Evento #{s.id_evento}</p>
                        )}
                      </>
                    }
                  />
                </Card>
              </Col>
            );
          })}
        </Row>
      )}
    </div>
  );
};

export default MisSeguimientos;
